import { render } from "./ForgetPassword.vue?vue&type=template&id=10212702&scoped=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"

import "./ForgetPassword.vue?vue&type=style&index=0&id=10212702&lang=css"
import "./ForgetPassword.vue?vue&type=style&index=1&id=10212702&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10212702"]])

export default __exports__